module.exports = __webpack_public_path__ + "img/Search.6628bd55.svg";